export const ReferrerPages = {
    roster: {
        code: 1,
        value: "roster",
    },
    home_access: {
        code: 2,
        value: "home_access",
    },
    custom_math_fact_assignment_pop_up: {
        code: 3,
        value: "custom_math_fact_assignment_pop_up",
    },
    adaptive_math_fact_assignment_pop_up: {
        code: 4,
        value: "adaptive_math_fact_assignment_pop_up",
    },
    curriculum_assignment_pop_up: {
        code: 5,
        value: "curriculum_assignment_pop_up",
    },
    download_letter_reminder_email: {
        code: 6,
        value: "download_letter_reminder_email",
    },
    teacher_dashboard_nudge: {
        code: 7,
        value: "teacher_dashboard_nudge",
    },
    springboard: {
        code: 8,
        value: "springboard_enrollment",
    },
    assignment_page_nudge: {
        code: 9,
        value: "assignment_page_nudge"
    },
    default: {
        code: 10,
        value: "default"
    },
    springboard_certificate: {
        code: 11,
        value: "springboard_certificate",
    },
    teacher_onboarding_page: {
        code: 12,
        value: "teacher_onboarding_page"
    },
    live_klass: {
        code: 16,
        value: "live_klass",
    },
    topic_assignment_pop_up: {
        code: 17,
        value: "topic_assignment_pop_up",
    },
    assignment_page_share_icon: {
        code: 18,
        value: "assignment_page_share_icon"
    },
    book_library: {
        code: 19,
        value: "book_library",
    },
    splash_league: {
        code: 20,
        value: "splash_league",
    },
    splash_league_reports: {
        code: 21,
        value: "splash_league_reports"
    },
    class_insights_report: {
        code: 22,
        value: 'class_insights_report'
    }
}

export const REFERRER_PAGE_MAP = Object.fromEntries(
    Object.entries(ReferrerPages).map(([key, obj]) => [obj.code.toString(), obj.value])
);

// [AI GENERATED CODE] SL-20161: Maps numeric tr_sub_source codes to their string values.
// Code 1 = one_time_report_email, Code 2 = recurring_report_email.
// Returns undefined for unknown codes so callers can guard with presence check.
export const SUB_SOURCE_MAP: Record<string, string> = {
    "1": "one_time_report_email",
    "2": "recurring_report_email",
    "3": "assignment_email",
    "4": "assessment_email",
    "5": "math_facts",
};

export const ReferralStatus = {
  ACTIVE: "active",
  CONSUMED: "consumed",
  REVOKED: "revoked",
}
